import { render } from "./PackageProgress.vue?vue&type=template&id=3f416e64&scoped=true"
import script from "./PackageProgress.vue?vue&type=script&lang=js"
export * from "./PackageProgress.vue?vue&type=script&lang=js"

import "./PackageProgress.vue?vue&type=style&index=0&id=3f416e64&scoped=true&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f416e64"]])

export default __exports__